import { defineAsyncComponent } from "vue";

export default Object.assign(
  {},
  defineAsyncComponent(() => import("./column-list-m2o.vue")),
  {
    Filter: defineAsyncComponent(() => import("./filter.vue")),
  },
);
